import { render, staticRenderFns } from "./Proprietaire.vue?vue&type=template&id=06740880&scoped=true&"
import script from "./Proprietaire.vue?vue&type=script&lang=js&"
export * from "./Proprietaire.vue?vue&type=script&lang=js&"
import style0 from "./Proprietaire.vue?vue&type=style&index=0&id=06740880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06740880",
  null
  
)

export default component.exports